import React from 'react';
import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <path d="M4.43414 17.5016H0.790314V5.81797H4.43414V17.5016ZM2.61027 4.22422C1.44509 4.22422 0.5 3.26328 0.5 2.10312C0.5 1.54586 0.722331 1.01142 1.11808 0.617372C1.51384 0.223326 2.05059 0.00195312 2.61027 0.00195312C3.16995 0.00195312 3.7067 0.223326 4.10245 0.617372C4.4982 1.01142 4.72054 1.54586 4.72054 2.10312C4.72054 3.26328 3.77505 4.22422 2.61027 4.22422ZM18.0718 17.5016H14.4358V11.8141C14.4358 10.4586 14.4084 8.72031 12.5414 8.72031C10.6469 8.72031 10.3565 10.193 10.3565 11.7164V17.5016H6.71664V5.81797H10.2114V7.41172H10.2624C10.7489 6.49375 11.9372 5.525 13.7101 5.525C17.3978 5.525 18.0758 7.94297 18.0758 11.0836V17.5016H18.0718Z" />
  </>,
  'Linkedin',
);
